export default __webpack_public_path__ + "static/media/paperplane_elite.6c5f7df3.gif";